module.exports = __webpack_public_path__ + "static/media/bs.cbc10545.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bs.svg
// module id = 875
// module chunks = 0